import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterLinkActive, RouterLink} from '@angular/router';
import {NgClass, NgForOf, NgIf} from '@angular/common';
import {filter, tap} from 'rxjs/operators';

@Component({
    selector: 'app-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.css'],
    imports: [
        RouterLinkActive,
        RouterLink,
        NgIf,
        NgClass,
        NgForOf
    ]
})
export class MenuItemComponent implements OnInit {
  @Input() link: string;
  @Input() name: string;
  @Input() icon: string;
  @Input() subItems: any[];
  @Input() id: string;
  @Input() route: string;
  @Input() params: any;
  @Input() fragment: string;
  showSub = false;
  isNotAbstract: boolean;

  constructor(public router: Router, public activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    // get start at load
    this.showSub = this.subItemsActive() || this.router.url.includes(this.route)

    // and stay up to date
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      tap(() => this.showSub = this.subItemsActive() || this.router.url.includes(this.route))
    ).subscribe()
    // this.isNotAbstract = !this.$state.get(this.state).abstract;
  }

  isActive(link) {
    if (location.pathname + location.search === link) {
      if (this.subItems !== undefined) {
        this.showSub = true;
      }
      return 'active';
    }
  }

  containsParams(subItem) {
    let x = true;
    if (subItem.params) {
      const currentParams = this.activatedRoute.snapshot.queryParams;
      x = Object.keys(subItem.params).filter(k => subItem.params[k]).every(key => currentParams[key] === subItem.params[key].toString());
    }
    if (subItem.fragment || this.activatedRoute.snapshot.fragment) {
      x = x && this.activatedRoute.snapshot.fragment === subItem.fragment;
    }
    return x;
  }

  subItemsActive() {
    return this.subItems?.filter(item => window.location.pathname.includes(item.route)).length > 0;
  }
  //
  // go(path) {
  //   if (path !== '') {
  //     if (this.$state !== undefined) {
  //       window.location = path;
  //     }
  //   } else {
  //     this.showSub = !this.showSub;
  //   }
  // }
}
